import { Moment } from "moment";
import Utils from "../utils";
import { SyncModel, SyncDataModel, DataModel } from "./syncModel";
import { CoreLanguages } from "../../languages/languages";
import { InternationalisationService } from "../../forked/angular-internationalisation";

export class LikeGroupViewModel {
  public contentType: number;
  public contentkey: string;
  public get contentName(): string {
    return CoreLanguages[InternationalisationService.locale].phUserLike_ContentType[this.contentkey];
  }
  public count: number;
}

// Requests
export class LikeSyncModel extends SyncModel {
  public likes: SetLikeModel[];
}

export class SetLikeModel {
  public content_type: number;
  public content_id: number;
  public like: boolean;
}

// Responses
export class LikeDataModel extends DataModel {
  public get DM_Key(): number | string { return this.content_type + "|" + this.content_id; }
  public content_type: number;
  public content_id: number;
  public deleted: boolean;
  public create_at_ymd: number;
  public create_at_hms: number;
  public get change_at(): Moment {
    return Utils.GetMomentFromInt(this.create_at_ymd, this.create_at_hms);
  }
}

export class LikeSyncDataModel extends SyncDataModel {
  public likes: LikeDataModel[];
  public get models(): DataModel[] { return this.likes; }
  public DeserializeType(): void {
    this._DeserializeType(LikeDataModel);
  }
}
